import cardList from './CardList/config';
import simpleList from './SimpleList/config';
import appbar from './AppBar/config';
import icon from './IconButton/config';
import button from './Button/config';
import toggle from './Toggle/config';
import switchButton from './Switch/config';
import tabNavigator from './TabNavigator/config';
import actionButton from './ActionButton/config';
import line from './Line/config';
import map from './Map/constans/config';
import barCode from './BarCode/config';
import barCodeScanner from './BarcodeScanner/config';
// import lineLogin from '@appos/components/LineLogin/config';
// import docomoLogin from '@appos/components/DocomoLogin/config';
// import didLogin from '@appos/components/DIDLogin/config';
// import trustdockLogin from '@appos/components/TrustdockLogin/config';
import calendar from '@appos/components/Calendar/config';
import stripePayment from './StripePayment/config';
import stripePaymentSecurity from '@appos/components/StripePaymentSecurity/config';
import stripeSubscription from './StripeSubscription/config';
import carousel from './Carousel/config';
// import appleLogin from './AppleLogin/config';
import horizontalCardList from './HorizontalCardList/config';
import chipList from './ChipList/config';
import avatarList from './AvatarList/config';
// import customHorizontalList from '@appos/components/CustomHorizontalList/config';
// import customButton from '@appos/components/CustomButton/config';
// import RankingList from '@appos/components/RankingList/config';
// import SelectList from '@appos/components/SelectList/config';
import ChangeQuantity from './ChangeQuantity/config';
// import InAppPurchase from '@appos/components/InAppPurchase/config';
// import CustomerChat from '@appos/components/CustomerChat/config';
// import univaPay from './UnivaPay/config';
// import univaPaySubscription from './UnivaPaySubscription/config';

export const config = {
  ActionButton: actionButton,
  AppBar: appbar,
  // AppleLogin: appleLogin,
  AvatarList: avatarList,
  BarCode: barCode,
  BarcodeScanner: barCodeScanner,
  Button: button,
  Calendar: calendar,
  CardList: cardList,
  Carousel: carousel,
  ChipList: chipList,
  // DIDLogin: didLogin,
  // DocomoLogin: docomoLogin,
  HorizontalCardList: horizontalCardList,
  Icon: icon,
  Line: line,
  // LineLogin: lineLogin,
  Map: map,
  SimpleList: simpleList,
  StripePayment: stripePayment,
  StripeSubscription: stripeSubscription,
  Switch: switchButton,
  TabNavigator: tabNavigator,
  Toggle: toggle,
  // TrustdockLogin: trustdockLogin,
  // UnivaPay: univaPay,
  // UnivaPaySubscription: univaPaySubscription,
  // liverhouse elements
  // CustomButton: customButton,
  // CustomHorizontalList: customHorizontalList,
  // InAppPurchase: InAppPurchase,
  StripePaymentSecurity: stripePaymentSecurity,
  ChangeQuantity,
  // RankingList,
  // SelectList,
  // CustomerChat,
  // end liverhouse elements
};

export default {
  components: [
    cardList,
    simpleList,
    appbar,
    icon,
    button,
    toggle,
    switchButton,
    tabNavigator,
    actionButton,
    line,
    map,
    // lineLogin,
    // docomoLogin,
    // didLogin,
    // trustdockLogin,
    calendar,
    stripePayment,
    stripePaymentSecurity,
    stripeSubscription,
    barCode,
    barCodeScanner,
    carousel,
    // appleLogin,
    horizontalCardList,
    chipList,
    avatarList,
    // customHorizontalList,
    // customButton,
    // RankingList,
    // SelectList,
    ChangeQuantity,
    // InAppPurchase,
    // CustomerChat,
    // univaPay,
    // univaPaySubscription,
  ],
};
